import { type CounterEffect, type SetSwitchProps, type SetCounterProps, type SetVariableProps, type SetNewGameProps, type MapState, type SetEnvironmentGridProps, type SetDayLightGridProps, type SetNightLightGridProps, type SetLightGridProps, type LoadMapProps, type SetPlayerPositionProps, type TravelProps, type ControllerDirection, type startPlayerMovementProps} from 'src/types'

// === PRIMITIVES === //
const setSwitch = (dispatch: (arg0: SetSwitchProps) => void, switchID: string, boolean: boolean) => {
  dispatch({
    type: 'SET_SWITCH',
    switchID,
    boolean
  })
}

const setGameStarted = (dispatch: (arg0: SetSwitchProps) => void, boolean: boolean) => {
  dispatch({
    type: 'SET_SWITCH',
    switchID: 'game_started',
    boolean
  })
}

const setAPIDataLoaded = (dispatch: (arg0: SetSwitchProps) => void, boolean: boolean) => {
  dispatch({
    type: 'SET_SWITCH',
    switchID: 'api_data_loaded',
    boolean
  })
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const setPlayerPosition = (dispatch: (arg0: SetPlayerPositionProps) => void, player_y: number, player_x: number) => {
  dispatch({
    type: 'SET_PLAYER_POSITION',
    player_y,
    player_x
  })
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const travel = (dispatch: (arg0: TravelProps) => void, player_y: number, player_x: number, id: string) => {
  dispatch({
    type: 'TRAVEL',
    location_id: id,
    player_y,
    player_x
  })
}

const setCounter = (dispatch: (arg0: SetCounterProps) => void, counterID: string, counterEffect: CounterEffect) => {
  dispatch({
    type: 'SET_COUNTER',
    counterID,
    counterEffect
  })
}

const setVariable = (dispatch: (arg0: SetVariableProps) => void, variableID: string, string: string) => {
  dispatch({
    type: 'SET_VARIABLE',
    variableID,
    string
  })
}

// grid
const setEnvironmentGrid = (dispatch: (arg0: SetEnvironmentGridProps) => void, contentGrid: MapState['contentGrid']) => {
  dispatch({
    type: 'SET_ENVIRONMENT_GRID',
    contentGrid
  })
}

const setLightGrid = (dispatch: (arg0: SetLightGridProps) => void, lightGrid: MapState['lightGrid']) => {
  dispatch({
    type: 'SET_LIGHT_GRID',
    lightGrid
  })
}

const resetMap = (dispatch: (arg0: SetNewGameProps) => void) => {
  dispatch({
    type: 'RESET_MAP'
  })
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const loadMap = (dispatch: (arg0: LoadMapProps & { type: string }) => void, { contentGrid, lightGrid }: LoadMapProps) => {
  dispatch({
    type: 'LOAD_MAP',
    contentGrid,
    lightGrid
  })
}

const setMapLoaded = (dispatch: (arg0: SetSwitchProps) => void, boolean: boolean) => {
  dispatch({
    type: 'SET_SWITCH',
    switchID: 'map_loaded',
    boolean
  })
}

export {
  travel,
  setSwitch,
  setGameStarted,
  setAPIDataLoaded,
  setPlayerPosition,
  setMapLoaded,
  setCounter,
  setVariable,
  setEnvironmentGrid,
  setLightGrid,
  resetMap,
  loadMap
}
